/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Form as NXUIForm } from '@nexigendigital/nxui'
import { toggleIDProtection } from 'store/slices/shopSlice'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    idProtection: boolean,
    domainName: string,
    addedItem: undefined | {
        id_protection?: boolean
    }
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function IdProtectionToggle({ id, idProtection, domainName, addedItem }: Props) {
    const dispatch = useAppDispatch()

    function checkIDProtection() {
        if (!addedItem) {
            return false
        }

        return Boolean(addedItem.id_protection)
    }

    if (idProtection) {
        return (
            <Toggle>
                <NXUIForm.Switch
                    checked={checkIDProtection()}
                    disabled={!addedItem}
                    onClick={() => dispatch(toggleIDProtection({
                        product_id: id,
                        name: domainName,
                        id_protection: checkIDProtection()
                    }))}
                />
            </Toggle>
        )
    }

    return null
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const Toggle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`
